// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3cGRB","header":"PatientQuestionnaire_header__1m2xB","info":"PatientQuestionnaire_info__1hfub"};